export default {
    parameters: {
        landing_id: "IDdis",
    },
    downtimeUrl: "https://id2.kodland.tech",
    ageRules: {
      min: 5,
      max: 17,
    },
    startPage: {
      image: "/welcome/quiz_project_girl.jpeg",
      title: "Daftar sekarang untuk mendapatkan pelajaran animasi dan kreativitas digital pertama yang disesuaikan dengan kebutuhan anak dan akses yang tak terbatas!",
      subtitle:
        "Kelas online ini akan mengajarkan anak-anak tentang dasar-dasar animasi, kartun, pemodelan 3D, hingga membuat karya pertama mereka.",
      button: "Mulai  🚀",
    },
    successPage: {
      title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran 🚀 GRATIS 🚀",
      subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
      button: "📆 Pesan",
    },
    quizRotateBySteps: {
      1: {
        question: "Apa mata pelajaran kesukaan anak Anda?",
        answers: [
          "🔬 Sains",
          "🎨 Seni dan desain",
          "💻 Ilmu komputer",
          "🏛️ Ilmu budaya (Sejarah, Literasi, dsb.)",
          "📐 Matematika",
          "💬 Ilmu Bahasa",
          "🤩 Semua yang di atas",
        ],
      },
      2: {
        question: "Bagaimana biasanya anak Anda menghabiskan waktu luangnya?",
        answers: [
          "📱 Bermain game di HP atau komputer",
          "👽 Menonton kartun",
          "♟️ Bermain permainan papan",
          "👨‍👩‍👧‍👦 Menghabiskan waktunya dengan keluarga",
          "👥 Menghabiskan waktunya dengan teman",
          "⛹️ Bermain kegiatan olahraga",
          "🎨 Melakukan aktivitas seni: menggambar, musik, akting, dsb.",
        ],
      },
      3: {
        question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
        answers: [
          "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
          "⛹️ Ya. Kegiatan olahraga",
          "🎨 Ya. Kelas seni",
          "💻 Ya. Kelas koding dan ilmu komputer",
          "🏕️ Ya. Pramuka",
          "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
        ],
      },
    },
  };
  
  